// extracted by mini-css-extract-plugin
export default {"headerFont":"\"Reem Kufi Ink\"","textFont":"\"Montserrat\""};